import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  UFInput,
  UFInputNumber,
  UFSwitch,
} from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  fetchSingleVoucherMAster,
  postFinanceVoucherType,
} from "../../../services/finance/finance"
import VoucherTypes from "../../../components/Common/chooseFields/voucherTypes"

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const isEdit = !!props?.editItem?.modal

  const schema = yup.object().shape({
    voucher_name: yup.string().required("Voucher Name is Required"),
    // parent_id: yup.mixed().required("Voucher Type is Required"),
    parent_id: yup.mixed().when([], {
      is: () => !isEdit,
      then: schema => schema.required("Voucher Type is Required"),
      otherwise: schema => schema.notRequired(),
    }),
    prefix: yup.string().required("Prefix is Required"),
    no_of_digits: yup
      .number()
      .typeError("No of Digits must be a number")
      .required("No of Digits is Required")
      .min(1, "No of Digits must be at least 1")
      .max(50, "No of Digits must be at most 50"),
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)
  // const [groupFields, setGroupFields] = useState([])

  const fetchData = async id => {
    const responce = await fetchSingleVoucherMAster(id)
    console.log(`responce`, responce)
  }

  useEffect(() => {
    if (props?.editItem?.modal) {
      console.log(`props?.editItem?.value?.parent`, props?.editItem)

      // fetchData(props?.editItem?.value?.id)

      reset({
        ...props?.editItem?.value,
        parent_id: props?.editItem?.value?.parent
          ? {
              value: props?.editItem?.value?.parent?.id,
              label: props?.editItem?.value?.parent?.voucher_type,
              type: props?.editItem?.value?.parent?.type,
            }
          : null,
        no_of_digits: props?.editItem?.value?.prefix?.no_of_digits || "",
        prefix: props?.editItem?.value?.prefix?.prefix || "",
        year: props?.editItem?.value?.prefix?.year,
        month: props?.editItem?.value?.prefix?.month,
        yearly_reset: props?.editItem?.value?.prefix?.yearly_reset,
        monthly_reset: props?.editItem?.value?.prefix?.monthly_reset,
        mannual_override: props?.editItem?.value?.prefix?.mannual_override,
      })
    }
  }, [props?.editItem?.modal])

  const handleSeriesAdd = async data => {
    console.log(`regist---`, data)

    try {
      setIsLoading(true)
      const createdSeries = await postFinanceVoucherType({
        ...data,
        parent_id: data?.parent_id?.value,
        voucher_name: data?.voucher_name,
        voucher_type: data?.voucher_name,
        category: data?.parent_id?.label ? data?.parent_id?.label : data?.voucher_name,
        description: data?.description || data?.parent_id?.label,
        model_name: "VoucherEntry",
        display_name: "Voucher - " + data?.voucher_name,
        is_voucher: 1,
        prefix: data?.prefix,
        no_of_digits: data?.no_of_digits,
        year: data?.year ? 1 : 0,
        month: data?.month ? 1 : 0,
        yearly_reset: data?.yearly_reset ? 1 : 0,
        monthly_reset: data?.monthly_reset ? 1 : 0,
        mannual_override: data?.mannual_override ? 1 : 0,
      })
      toastSuccess(createdSeries?.message)
      reset()
      close()
      onUpdate && onUpdate(createdSeries?.data)
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>
            {props?.editItem?.modal ? "Edit Voucher Type" : "New Voucher Type"}
          </h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleSeriesAdd)}>
                <Row>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Voucher Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Voucher Name"
                        name={"voucher_name"}
                        invalid={!!errors.voucher_name}
                      />
                      <FormFeedback invalid>
                        {errors.voucher_name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Voucher Type<span className="mandatory">*</span>
                      </Label>
                      <VoucherTypes
                        control={control}
                        placeholder="Select the Voucher Type"
                        name={"parent_id"}
                        clearable={true}
                        invalid={!!errors.parent_id}
                        // parentChk={true}
                      />
                      <FormFeedback invalid>
                        {errors.parent_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Prefix<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter Prefix"
                        name={"prefix"}
                        invalid={!!errors.prefix}
                      />
                      <FormFeedback invalid>
                        {errors.prefix?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        No. of Digits<span className="mandatory">*</span>
                      </Label>
                      <UFInputNumber
                        control={control}
                        placeholder="Enter No of Digits"
                        name="no_of_digits"
                        maxNum={50}
                      />
                      <FormFeedback invalid>
                        {errors.no_of_digits?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Row>
                        <Col lg={6}>Year</Col>
                        <Col lg={6}>
                          <UFSwitch
                            control={control}
                            placeholder="Enter Prefix"
                            name={`year`}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Row>
                        <Col lg={6}>Yearly Reset</Col>
                        <Col lg={6}>
                          <UFSwitch
                            control={control}
                            placeholder="Enter Prefix"
                            name={`yearly_reset`}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Row>
                        <Col lg={6}>Month</Col>
                        <Col lg={6}>
                          <UFSwitch
                            control={control}
                            placeholder="Enter Prefix"
                            name={`month`}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Row>
                        <Col lg={6}>Monthly Reset</Col>
                        <Col lg={6}>
                          <UFSwitch
                            control={control}
                            placeholder="Enter Prefix"
                            name={`monthly_reset`}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-4">
                      <Row>
                        <Col lg={6}>Override</Col>
                        <Col lg={6}>
                          <UFSwitch
                            control={control}
                            placeholder="Enter Prefix"
                            name={`mannual_override`}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditVoucherMaster = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])
  useEffect(() => {
    if (props?.show) {
      setModal(true)
    }
  }, [props?.show])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditVoucherMaster
